import { render, staticRenderFns } from "./Short.vue?vue&type=template&id=55fbbdbc"
import script from "./Short.vue?vue&type=script&lang=js"
export * from "./Short.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports